module.exports = __webpack_public_path__ + "static/media/icon.12081ece.png";